import { prettify } from "../../../utils/utils";
import { EditableInputDisplay } from "../../EditableComponents";

const getColumns = (setEditMode, setParentValue) => {
  return [
    {
      muiTableHeadCellProps: { sx: { fontWeight: "bold" } },
      size: 150,
      Cell: ({ cell, row }) => (
        <EditableInputDisplay 
          label={null}
          id={"first_name"}
          setEditMode={setEditMode}
          initialValue={row.original.first_name}
          inputMode={"text"}
          setParentValue={setParentValue}
        />
      ),
      header: "Nome",
    },
    {
      muiTableHeadCellProps: { sx: { fontWeight: "bold" } },
      size: 150,
      Cell: ({ cell, row }) => (
        <EditableInputDisplay
          label={null}
          id={"last_name"}
          setEditMode={setEditMode}
          initialValue={row.original.last_name}
          inputMode={"text"}
          setParentValue={setParentValue}
        />
      ),
      header: "Cognome",
    },
    {
      muiTableHeadCellProps: { sx: { fontWeight: "bold" } },
      size: 100,
      accessorFn: (row) => `${prettify(row.profile)}`,
      header: "Profilo",
    },
    {
      muiTableHeadCellProps: { sx: { fontWeight: "bold" } },
      size: 5,
      filterVariant: "checkbox",
      accessorKey: "is_active",
      Cell: ({ row }) => (
        <EditableInputDisplay
          label={null}
          id={"is_active"}
          setEditMode={setEditMode}
          initialValue={row.original.is_active}
          inputMode={"bool"}
          setParentValue={setParentValue}
        />
      ),
      header: "Attivo",
    },
    {
      muiTableHeadCellProps: { sx: { fontWeight: "bold" } },
      size: 150,
      Cell: ({ cell, row }) => (
        <EditableInputDisplay
          label={null}
          id={"piva"}
          setEditMode={setEditMode}
          initialValue={row.original.piva}
          inputMode={"text"}
          setParentValue={setParentValue}
        />
      ),
      header: "Partita IVA",
    },
    {
      muiTableHeadCellProps: { sx: { fontWeight: "bold" } },
      size: 150,
      Cell: ({ cell, row }) => (
        <EditableInputDisplay
          label={null}
          id={"iban"}
          setEditMode={setEditMode}
          initialValue={row.original.iban}
          inputMode={"text"}
          setParentValue={setParentValue}
        />
      ),
      header: "IBAN",
    },
  ];
};

export default getColumns;
